import axios from 'axios';

export const HTTPDSP = axios.create({
  baseURL: `https://waznk.sd.zain.com/DSPAPIs/APIs/`
})
